import { createFileRoute } from "@tanstack/react-router";

import { FinancingI4fHowItWorksPage } from "@/components/financing/financing-i4f-how-it-works-page";
import {
  FINANCING_I4F_FAQS,
  FINANCING_I4F_HOW_IT_WORKS_META,
  FINANCING_I4F_HOW_IT_WORKS_PATH,
} from "@/content/financing-i4f-how-it-works";
import { pageSeo } from "@/lib/seo";

export const Route = createFileRoute("/financing-i4f-how-it-works")({
  head: () => ({
    ...pageSeo({
      path: FINANCING_I4F_HOW_IT_WORKS_PATH,
      title: FINANCING_I4F_HOW_IT_WORKS_META.title,
      description: FINANCING_I4F_HOW_IT_WORKS_META.description,
      ogType: "website",
    }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FINANCING_I4F_FAQS.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
  component: FinancingI4fHowItWorksPage,
});
